/**
 * The Web `Storage` adapter — the browser and Electron-renderer arm, and the
 * only adapter with durable production writers. Takes `Storage` by constructor
 * argument rather than reading the global, so the conformance table exercises
 * it without touching globals.
 */
import type { SDKStorage } from './types.js';

export class WebStorageAdapter implements SDKStorage {
  constructor(
    private readonly storage: Storage,
    readonly scopeId = 'web:local',
  ) {}

  getItem(key: string): string | null {
    return this.storage.getItem(key);
  }

  setItem(key: string, value: string): void {
    this.storage.setItem(key, value);
  }

  removeItem(key: string): void {
    this.storage.removeItem(key);
  }

  keys(): string[] {
    const out: string[] = [];
    for (let i = 0; i < this.storage.length; i++) {
      const k = this.storage.key(i);
      if (k !== null) out.push(k);
    }
    return out;
  }
}
